import { React, useState } from 'react';
import './App.css';
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Jumbotron,
  InputGroup,
  FormControl,
  Modal
} from 'react-bootstrap';
import LeadgenFormModal from './LeadgenFormModal';

function App() {
  const [modalShow, setModalShow] = useState(false);
  const handleClick = () => {
    setModalShow(true);
  };
  return (
    <>
      <div className=''>
        {/* Header starts */}
        <header className='menuheader'>
          <Container>
            <Row className='justify-content-space-between'>
              <Navbar expand='lg' className='w-100'>
                <Navbar.Brand href='#' className='logo'>
                  <div className='logo'>
                    <img src='https://vcdn.tyroo.com/uploaded-files/TyrooLogoWhite11png20210617072834.png' />
                  </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls='responsive-navbar-nav navbarScroll' />
                <Navbar.Collapse id='navbarScroll'>
                  <Nav
                    className='ml-auto my-2 my-lg-0'
                    style={{ maxHeight: '100%' }}
                    navbarScroll
                  >
                    {/* <Nav.Link href='#about-us'>About Us</Nav.Link> */}
                    {/* <Nav.Link href='#partners'>Partners</Nav.Link> */}
                    <Nav.Link href='#snapchat'>Quảng cáo Snapchat</Nav.Link>
                    <Nav.Link href='#contact'>Liên hệ</Nav.Link>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        marginLeft: '40px'
                      }}
                    >
                      <div style={{ width: '15px', lineHeight: '0' }}>
                        <img
                          style={{ width: '100%' }}
                          src='https://vcdn.tyroo.com/uploaded-files/globe2png20211022121725.png'
                        />
                      </div>
                      <Nav.Link
                        style={{ paddingRight: '0', fontWeight: 'bold' }}
                        href='https://tyroo.com/'
                      >
                        EN
                      </Nav.Link>
                      /
                      <Nav.Link
                        style={{ paddingLeft: '0', fontWeight: 'bold' }}
                        href='https://vietnam.tyroo.com/'
                      >
                        VN
                      </Nav.Link>
                    </div>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </Row>
          </Container>
        </header>
        {/* Header ends  */}

        {/* First section starts */}
        <section className='firstSection'>
          <div className='themeBackground'>
            <Container>
              <Row>
                <Col lg='6'>
                  <Container>
                    <Row className='flexProperty'>
                      <div className='jumbotron'>
                        <div className='banner-img'>
                          <img src='https://vcdn.tyroo.com/uploaded-files/snap2web2Vpng20210823123901.png' />
                        </div>
                      </div>
                    </Row>
                  </Container>
                </Col>
                <Col lg='6'>
                  <Container>
                    <Row className='flexProperty'>
                      <div className=''>
                        <Jumbotron>
                          <p className='text-white'>
                            {/* Interested in <br></br> understanding about <br></br>{' '}
                          Snapchat as an ad <br></br>Platform? */}
                            Đại diện bán hàng được ủy quyền của Snapchat tại Ấn
                            Độ, Việt Nam, Thái Lan và Philippines
                          </p>
                          <button className='booking-btn' onClick={handleClick}>
                            biêt nhiêu hơn
                          </button>
                        </Jumbotron>
                      </div>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Container>
          </div>
          {/* <div id='about-us'>
          <Container>
            <Row>
              <Col>
                <div className='banner-content text-center'>
                  <div className='heading'>
                    <h3>We are Tyroo?</h3>
                  </div>
                  <p>
                    We are Tyroo, a leading marketing technology company working
                    with enterprises to help them deliver business outcomes at
                    scale. We are the preferred entry partner for Internet
                    companies looking to grow in India and SEA as a region.
                    Currently, we are Snapchat's authorized Sales representative
                    for India, Vietnam, Thailand, and the Philippines region. 
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div> */}
        </section>
        {/* First section ends */}

        {/* Second section starts */}
        {/* <section id='partners' className='secondSection p-top-bottom'>
        <Container>
          <Row>
            <Col>
              <div className='heading'>
                <h3>Partners</h3>
              </div>
            </Col>
          </Row>
          <Row className='flexProperty'>
            <Col lg='6'>
              <Row className='flexProperty'>
                <Col lg='6'>
                  <div className='side-image mb-lg-0 mb-3'>
                    <img src='https://vcdn.tyroo.com/uploaded-files/AnimatedYogaInstagramPost1png20210708105451.png' />
                  </div>
                </Col>
                <Col lg='6'>
                  <div className='side-image'>
                    <video autoplay controls preload='auto' muted>
                      <source
                        src='https://vcdn.tyroo.com/uploaded-files/PocketGemsReEngagementCreativemp420210706110414.mp4'
                        type='video/mp4'
                      />
                    </video>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg='6'>
              <div className='side-content'>
                <p>
                  Tyroo is the Official Monetization partner for Snapchat for
                  India, Vietnam, Philippines & Thailand.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
        {/* Second section ends */}

        {/* Third section starts */}
        <section id='snapchat' className='thirdsection p-top-bottom'>
          <Container>
            {/* <Row>
            <Col>
              <div className='heading'>
                <h3>Snapchat for business</h3>
              </div>
            </Col>
          </Row> */}
            <Row className='flexProperty'>
              <Col lg='7' md='6' sm='12'>
                <div className='text-center'>
                  <p>
                    Quảng cáo Snapchat dành cho doanh nghiệp thuộc mọi quy mô,
                    ngành nghề. Hãy tham gia các cuộc trò chuyện hàng ngày của
                    Snapchatter với quảng cáo kỹ thuật số toàn màn hình để
                    thuyết phục những người quan trọng nhất đối với doanh nghiệp
                    của bạn hành động.
                  </p>
                </div>
                <div>
                  <Container>
                    <Row>
                      <Col>
                        <div className='sub-heading'>
                          Giải pháp cho mọi ngành nghề
                        </div>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col>
                        <div className='block-content'>
                          <div className='block-img'>
                            <img src='https://vcdn.tyroo.com/uploaded-files/ecommercepng20210728080412.png' />
                          </div>
                          <h6>Doanh nghiệp Thương mại Điện tử</h6>
                          <p>
                            Thúc đẩy doanh số bán hàng trực tuyến và các hành
                            động mong muốn trên trang web.
                          </p>
                        </div>
                      </Col>
                      <Col>
                        <div className='block-content'>
                          <div className='block-img'>
                            <img src='https://vcdn.tyroo.com/uploaded-files/consolepng20210728080546.png' />
                          </div>
                          <h6>Nhà phát triển Ứng dụng & Game</h6>
                          <p>
                            Tăng lượt cài đặt ứng dụng và thu hút người dùng
                            quay lại ứng dụng.
                          </p>
                        </div>
                      </Col>
                      <Col>
                        <div className='block-content'>
                          <div className='block-img'>
                            <img src='https://vcdn.tyroo.com/uploaded-files/buldingpng20210728081039.png' />
                          </div>
                          <h6>Doanh nghiệp địa phương</h6>
                          <p>
                            Tăng lưu lượng khách hàng bằng cách nhắm mục tiêu
                            dựa trên vị trí.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                  <div className='text-center'>
                    <h6 style={{ textDecoration: 'underline' }}>
                      <a
                        style={{ color: '#fff', fontSize: '16px' }}
                        target='_blank'
                        href='https://forbusiness.snapchat.com/inspiration?region=asia-pacific'
                      >
                        Nhận quyền truy cập vào Nghiên cứu điển hình Snapchat
                      </a>
                    </h6>
                  </div>
                </div>
              </Col>
              <Col lg='5' md='6' sm='12'>
                {/* <div className='side-image'>
                <img src='https://vcdn.tyroo.com/uploaded-files/AnimatedYogaInstagramPost2png20210709090749.png' />
              </div> */}
                <div className='side-image'>
                  <video autoplay controls preload='auto' muted>
                    <source
                      src='https://vcdn.tyroo.com/uploaded-files/PocketGemsReEngagementCreativemp420210706110414.mp4'
                      type='video/mp4'
                    />
                  </video>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Third section ends */}

        {/* Footer section starts */}
        <section id='contact' className='footersection'>
          <Container>
            <Row className='flexProperty'>
              <Col lg='6'>
                <div className='py-4 text-center'>
                  <div className='footer-logo'>
                    <img src='https://vcdn.tyroo.com/uploaded-files/TyrooLogoWhite11png20210617072834.png' />
                  </div>
                  <p className='mt-4 text-center'>
                    Tyroo là công ty công nghệ marketing hàng đầu cộng tác với
                    các doanh nghiệp để giúp đạt được kết quả kinh doanh trên
                    quy mô lớn. Chúng tôi là đối tác gia nhập thị trường ưu tiên
                    cho các công ty Internet muốn phát triển trên các thị trường
                    mới ở châu Á Thái Bình Dương.
                  </p>

                  {/* <a
                    target='_blank'
                    href='https://vn-website.s3-website-us-west-2.amazonaws.com'
                    className='text-white contact-link'
                  >
                    Tyroo - Vietnam
                  </a> */}
                </div>
              </Col>
              <Col lg='6'>
                <div>
                  <h5 className='bold text-center'>Liên hệ chúng tôi</h5>
                  <div>
                    <p className='mt-4 text-center'>
                      Tyroo, 22-153, floor 23, WeWork E. Town Central,  11 Đoàn
                      Văn Bơ, Phường 12, Quận 4, Thành phố Hồ Chí Minh <br></br>
                      Vietnam Spoc E-mail id : snap.sea@tyroo.com
                    </p>
                    {/* <InputGroup className='mb-3'>
                    <InputGroup.Text id='basic-addon3'>Email</InputGroup.Text>
                    <FormControl
                      id='basic-url'
                      aria-describedby='basic-addon3'
                      className='inputField'
                    />
                  </InputGroup> */}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Footer section ends */}
      </div>
      <LeadgenFormModal modalShow={modalShow} setModalShow={setModalShow} />
    </>
  );
}

export default App;
